export default "__VITE_ASSET__58e466fe__"